import { useMemo } from 'react';

const computeDeal = (bound: number, cote: number) => (1 + bound / 100) * cote;

export const useBadgesRanges = (
  refinedQuotation?: number,
):
  | {
      min: number;
      offMarket: number;
      veryGoodDeal: number;
      goodDeal: number;
      equitableDeal: number;
      badDeal: number;
      max: number;
    }
  | undefined => {
  return useMemo(() => {
    if (refinedQuotation !== undefined) {
      return {
        min: 0,
        offMarket: computeDeal(-50, refinedQuotation),
        veryGoodDeal: computeDeal(-12, refinedQuotation),
        goodDeal: computeDeal(-1, refinedQuotation),
        equitableDeal: computeDeal(12, refinedQuotation),
        badDeal: computeDeal(50, refinedQuotation),
        max: refinedQuotation * 2,
      };
    }
  }, [refinedQuotation]);
};
